import React, { useState, useCallback, memo } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import ReactTooltip from 'react-tooltip';

const styles = {
    btn: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
};

/**
 * @typedef {Object} AnnotateLikeProps
 * @property {(status: 'annotate' | 'gazetter') => void} changeTypeAnnotations - callback fired when annotation type changes
 * @property {boolean} [isSpam] - whether the mail type is spam
 */

/**
 * toggle button component for switching between 'annotate' and 'gazetter' modes
 * 
 * @param {AnnotateLikeProps} props
 */
const AnnotateLike = ({ changeTypeAnnotations, isSpam = false }) => {
    const [status, setStatus] = useState('annotate');

    const handleAnnotate = useCallback(() => {
        if (isSpam) return;
        const newStatus = status === 'annotate' ? 'gazetter' : 'annotate';
        setStatus(newStatus);
        changeTypeAnnotations(newStatus);
    }, [status, changeTypeAnnotations, isSpam]);

    return (
        <div className='btn'>
            <span
                data-tip={isSpam ? 'Mail type <b>spam</b>, can not annotate as <b>spam</b>' : null}
                data-for="spam-tooltip"
            >
                <RaisedButton
                    labelStyle={styles.btn.labelStyle}
                    style={styles.btn.style}
                    buttonStyle={styles.btn.buttonStyle}
                    label={status}
                    onClick={handleAnnotate}
                    disabled={isSpam}
                    primary
                />
            </span>
            {isSpam && (
                <ReactTooltip
                    id="spam-tooltip"
                    effect="solid"
                    html
                />
            )}
        </div>
    );
};

AnnotateLike.displayName = 'AnnotateLike';

export default memo(AnnotateLike);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Management/AnnotateLike.jsx